import { callQueryClientMethodWithQueryKey } from '../lib/callQueryClientFetchMethod.js';

const prefetchInfiniteQuery = (_, schema, args)=>{
    return callQueryClientMethodWithQueryKey('prefetchInfiniteQuery', schema, true, args);
};

export { prefetchInfiniteQuery };
//# sourceMappingURL=prefetchInfiniteQuery.js.map
